import { useEffect } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';

import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import ClientBrandingPage from './pages/ClientBrandingPage';
import MerchBrandingListPage from './pages/MerchBrandingListPage';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';

import { markActive, markInactive } from './utils/auth';

export default function App() {
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.hidden) {
        markInactive();
      } else {
        const valid = markActive();

        if (!valid) {
          window.location.href = '/login';
        }
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />

        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Layout>
                <DashboardPage />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/brandings"
          element={
            <ProtectedRoute allowedRoles={["admin", "client"]}>
              <Layout>
                <ClientBrandingPage />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/merch-brandings"
          element={
            <ProtectedRoute allowedRoles={["admin", "merch"]}>
              <Layout>
                <MerchBrandingListPage />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </BrowserRouter>
  );
}